var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.isInitializing ? _c('div', [_c('span', {
    staticClass: "fa fa-spinner fa-spin"
  })]) : _c('div', [_vm.error.length ? _c('div', {
    staticClass: "alert alert-danger"
  }, [_vm._v(" " + _vm._s(_vm.error) + " ")]) : _vm._e(), _vm.areAllColumnsInactive ? _c('div', {
    staticClass: "alert alert-info"
  }, [_vm._v(" Er zijn geen kolommen actief om te tonen ")]) : _vm._e(), !_vm.orders.length && !_vm.error.length ? _c('div', {
    staticClass: "alert alert-light"
  }, [_vm.isLoading ? _c('p', [_c('i', [_c('span', {
    staticClass: "fa fa-spinner fa-spin"
  }), _vm._v(" " + _vm._s(_vm.$t('omt.gui.general.label.is-searching')) + "...")]), _c('b-button', {
    staticClass: "ml-3 p-0",
    class: {
      'opacity-1': !_vm.showCancelButton
    },
    attrs: {
      "variant": "link",
      "size": "sm",
      "title": "Annuleren"
    },
    on: {
      "mouseenter": function ($event) {
        _vm.showCancelButton = true;
      },
      "mouseleave": function ($event) {
        _vm.showCancelButton = false;
      },
      "click": _vm.cancelSearch
    }
  }, [_c('font-awesome-icon', {
    staticClass: "text-danger",
    attrs: {
      "icon": "ban"
    }
  })], 1)], 1) : _c('i', [_vm._v(_vm._s(_vm.$t('omt.gui.general.label.no-results')))])]) : _c('div', [_c('b-checkbox-group', {
    model: {
      value: _vm.selectedOrders,
      callback: function ($$v) {
        _vm.selectedOrders = $$v;
      },
      expression: "selectedOrders"
    }
  }, [_c('table', {
    staticClass: "d-none d-md-table d-lg-table d-xl-table table orderlist"
  }, [_c('thead', [_c('tr', [_vm.hasBatchActions ? _c('th', {
    staticClass: "pr-0"
  }, [!_vm.selectedOrders.length ? _c('b-button', {
    staticClass: "p-0 ml-2",
    attrs: {
      "variant": "link",
      "title": "Alles selecteren"
    },
    on: {
      "click": function ($event) {
        return _vm.toggleSelection();
      }
    }
  }, [_c('font-awesome-icon', {
    staticClass: "text-secondary",
    attrs: {
      "icon": "far fa-check-square"
    }
  })], 1) : _c('b-button', {
    staticClass: "p-0 ml-2",
    attrs: {
      "variant": "link",
      "title": "Alles deselecteren"
    },
    on: {
      "click": function ($event) {
        return _vm.toggleSelection();
      }
    }
  }, [_c('font-awesome-icon', {
    staticClass: "text-secondary",
    attrs: {
      "icon": "far fa-square"
    }
  })], 1), _c('b-dropdown', {
    attrs: {
      "size": "sm",
      "variant": "light",
      "disabled": !_vm.isBatchActionMenuEnabled
    },
    scopedSlots: _vm._u([{
      key: "button-content",
      fn: function () {
        return [_c('font-awesome-icon', {
          attrs: {
            "icon": "bars"
          }
        })];
      },
      proxy: true
    }], null, false, 2205403328)
  }, _vm._l(_vm.batchActions, function (batchAction, batchActionIdentifier) {
    return _c('b-dropdown-item', {
      key: batchActionIdentifier,
      attrs: {
        "disabled": !!_vm.currentExecutionBatchActionIdentifier
      }
    }, [_c('b-overlay', {
      attrs: {
        "show": _vm.currentExecutionBatchActionIdentifier === batchActionIdentifier,
        "size": "sm"
      }
    }, [_c('b-button', {
      attrs: {
        "variant": "link",
        "size": "sm"
      },
      on: {
        "click": function ($event) {
          return _vm.executeBatchAction(batchActionIdentifier);
        }
      }
    }, [typeof batchAction.title === 'function' ? _c('span', [_vm._v(_vm._s(batchAction.title()))]) : _c('span', [_vm._v(_vm._s(batchAction.title))])])], 1)], 1);
  }), 1)], 1) : _vm._e(), _vm._l(_vm.columnsFiltered, function (column, index) {
    return _c('th', {
      key: index
    }, [_vm._v(" " + _vm._s(_vm.$t(column.name)) + " "), column.property === _vm.filters.sort_by ? _c('a', {
      staticClass: "lead ml-2 align-middle",
      attrs: {
        "href": "#"
      },
      on: {
        "click": function ($event) {
          $event.preventDefault();
          return _vm.toggleSortDirection.apply(null, arguments);
        }
      }
    }, [_vm.filters.sort_dir === 'desc' ? _c('sup', {
      staticClass: "fa fa-sort-down align-text-bottom"
    }) : _c('sub', {
      staticClass: "fa fa-sort-up align-middle"
    })]) : _vm._e()]);
  })], 2)]), _c('tbody', [_vm._l(_vm.orders, function (order, index) {
    return _c('tr', {
      key: index,
      staticClass: "clickable",
      on: {
        "click": function ($event) {
          return _vm.getOrderDetailRoute(order);
        }
      }
    }, [_vm.hasBatchActions ? _c('td', [_c('b-checkbox', {
      attrs: {
        "value": order
      }
    })], 1) : _vm._e(), _vm._l(_vm.columnsFiltered, function (column, index) {
      var _column$postProcess, _column$postProcess2;
      return _c('td', {
        key: index,
        staticClass: "p-0",
        class: {
          'text-nowrap': column.no_wrap
        }
      }, [_c('router-link', {
        staticClass: "d-inline-block p-2",
        class: {
          'text-decoration-line-through': _vm.isOrderCancelled({
            salesOrder: order
          }) && _vm.strikeThroughCancelledOrders,
          'text-blue': _vm.colorizeDealerChanges && _vm.dealerHasChanged({
            salesOrder: order
          }),
          'text-dark': !_vm.colorizeDealerChanges || !_vm.dealerHasChanged({
            salesOrder: order
          })
        },
        attrs: {
          "to": _vm.getOrderDetailRoute(order)
        }
      }, [column.identifier === 'orderIdentifier' ? [_vm.useIconForCancelledOrder && _vm.isOrderCancelled({
        salesOrder: order
      }) ? _c('FontAwesomeIcon', {
        staticClass: "text-danger mr-1",
        attrs: {
          "icon": "ban",
          "title": "Order volledig geannuleerd"
        }
      }) : _vm._e(), _vm.useIconForDealerChanges && _vm.dealerHasChanged({
        salesOrder: order
      }) ? _c('FontAwesomeIcon', {
        staticClass: "text-blue mr-2",
        attrs: {
          "icon": "info",
          "title": "Dealerchange heeft plaatsgevonden"
        }
      }) : _vm._e()] : _vm._e(), (_column$postProcess = column.postProcess) !== null && _column$postProcess !== void 0 && _column$postProcess.call(column, order[column.property]) ? _c('span', {
        domProps: {
          "innerHTML": _vm._s(_vm.$t((_column$postProcess2 = column.postProcess) === null || _column$postProcess2 === void 0 ? void 0 : _column$postProcess2.call(column, order[column.property])))
        }
      }) : _c('span', [_vm._v(" ")])], 2)], 1);
    })], 2);
  }), _vm.isLoading ? _c('tr', [_c('td', {
    attrs: {
      "colspan": _vm.columnsFiltered.length
    }
  }, [_c('span', {
    staticClass: "fa fa-spinner fa-spin"
  }), _vm._v(" " + _vm._s(_vm.$t('omt.gui.general.label.is-searching')) + "...")])]) : _vm._e()], 2)]), _vm._l(_vm.orders, function (order, index) {
    return _c('div', {
      key: index,
      staticClass: "d-md-none d-lg-none d-xl-none modal-content mt-3"
    }, [_c('div', {
      staticClass: "modal-header"
    }, [_c('strong', [_c('router-link', {
      staticClass: "btn btn-sm btn-primary mr-2",
      attrs: {
        "tag": "button",
        "to": _vm.getOrderDetailRoute(order)
      }
    }, [_c('span', {
      staticClass: "fa fa-eye"
    })]), _vm._v(" Order " + _vm._s(order.order_identifier) + " ")], 1)]), _c('div', {
      staticClass: "modal-body p-2"
    }, [_c('table', {
      staticClass: "table table-borderless table-sm"
    }, _vm._l(_vm.columnsFiltered, function (column, index) {
      var _column$postProcess3;
      return _c('tr', {
        key: index
      }, [_c('th', [_vm._v(_vm._s(_vm.$t(column.name)))]), _c('td', [_vm.useIconForCancelledOrder && column.identifier === 'orderIdentifier' && _vm.isOrderCancelled({
        salesOrder: order
      }) ? _c('FontAwesomeIcon', {
        staticClass: "text-danger mr-1",
        attrs: {
          "icon": "ban"
        }
      }) : _vm._e(), _vm._v(" " + _vm._s(_vm.$t((_column$postProcess3 = column.postProcess) === null || _column$postProcess3 === void 0 ? void 0 : _column$postProcess3.call(column, order[column.property]))) + " ")], 1)]);
    }), 0)])]);
  })], 2)], 1), _c('infinite-scroll', {
    attrs: {
      "show": !_vm.isLoading && !_vm.isLastPage && !_vm.error.length && !_vm.areAllColumnsInactive && !_vm.isCancelled
    },
    on: {
      "next": _vm.search
    }
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }